import React, { FC, useEffect } from 'react'
import { AnimatePresence } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { useGiveawayContext } from '../../context/GiveawayContext'
import { FloatingCtaButton } from './FloatingCtaButton'
import { FloatingShareButton } from './FloatingShareButton'

export const FloatingButtons: FC = () => {
  const { isActive, setIsShareModalOpen, scrollToProducts, content, heroContainerRef, mobileTicketContainerRef } =
    useGiveawayContext()

  const { ref: heroObserverRef, inView: isHeroInView } = useInView({
    threshold: 0.5,
    triggerOnce: false,
  })
  const { ref: mobileProductsObserverRef, inView: isMobileProductsInView } = useInView({
    threshold: 0,
    triggerOnce: false,
  })
  const { shareModal } = content

  useEffect(() => {
    if (heroContainerRef.current) {
      heroObserverRef(heroContainerRef.current)
    }
  }, [heroContainerRef, heroObserverRef])

  useEffect(() => {
    if (mobileTicketContainerRef.current) {
      mobileProductsObserverRef(mobileTicketContainerRef.current)
    }
  }, [mobileTicketContainerRef, mobileProductsObserverRef])

  if (!isActive) return null

  return (
    <AnimatePresence>
      <>
        {!isHeroInView && shareModal && (
          <FloatingShareButton
            onClick={() => setIsShareModalOpen(true)}
            className={!isMobileProductsInView ? 'bottom-24 md:bottom-[1.5rem]' : 'bottom-[1.5rem]'}
          />
        )}

        {!isHeroInView && !isMobileProductsInView && <FloatingCtaButton onClick={scrollToProducts} />}
      </>
    </AnimatePresence>
  )
}
